import { Formik, Form } from 'formik';
import React, { useMemo } from 'react';
import usersValidationSchema from './validationSchema';
import Input from 'component/atom/forms/input/input/Input';
import Select from 'component/atom/forms/select/select/Select';
import styles from './GroupForm.module.scss';
import { useFetch } from 'hooks/useFetch';
import { roleEndpoints, scriptEndpoints, userEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'app-context/user/UserContext';
import Loader from 'component/atom/loader/Loader';
import toast from 'react-hot-toast';
import { useToast } from 'app-context/toasterContext/ToastContext';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import TextArea from 'component/atom/forms/text-area/TextArea';
const GroupForm = ({
  id,
  data,
  isFetching,
  formRef,
  AddUser,
  EditUser,
  onClose,
  setRefetch,
  refetch,
  setSelectedUser,
}) => {
  const { updateProfileImage } = useUserContext();
  const { open: showToast } = useToast();
  const navigate = useNavigate();

  const { data: roles, isFetching: isFetchingRoles } = useFetch(
    ['getRoles'],
    roleEndpoints?.getRoles()
  );

  const { data: bots, isFetching: isFetchingBots } = useFetch(
    ['allBots'],
    scriptEndpoints.getBots()
  );

  const fetchedData = data?.data?.user?.[0];
  const initialvalues = {
    groupName: fetchedData?.groupName || '',
    description: fetchedData?.description || '',
    rolesAndPermissions: fetchedData?.rolesAndPermissions || '',
    chatbot: fetchedData?.chatbot || '',
  };
  const rolesOptions = useMemo(
    () =>
      roles?.data?.map((val) => ({
        value: val.rolesAndPermissions,
        label: val.roleName,
      })),
    [roles]
  );

  const botOptions = useMemo(
    () =>
      bots?.data?.map((val) => ({
        value: val.botId,
        label: val.botName,
      })),
    [bots]
  );

  const handleSubmitForm = (values) => {
    const payload = {
      id: id || null,
      groupName: values.groupName,
      description: values.description,
      userGroupDetails: values?.chatbot
        ? [
            {
              id: id || null,
              botId: values.chatbot,
            },
          ]
        : [],
    };

    console.log('GROUP PAYLOAD:', payload);
  };

  if (isFetching) {
    return <Loader isComponent />;
  }
  return (
    <Formik
      initialValues={initialvalues}
      validationSchema={usersValidationSchema(id)}
      enableReinitialize={true}
      onSubmit={(values) => {
        handleSubmitForm(values);
      }}
      innerRef={formRef}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <Form className={styles.formCont}>
            <div className={styles.cont}>
              <div className={styles.subCont}>
                <Input
                  label='Group Name'
                  placeholder='Enter Name'
                  name='groupName'
                  value={values.groupName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.groupName}
                  touched={touched.groupName}
                />
                <TextArea
                  label='Description'
                  value={values.description}
                  name='description'
                  onChange={handleChange}
                  error={errors.description}
                  touched={touched.description}
                  placeholder='Enter Description'
                />
                <Select
                  label='Role'
                  placeholder='Select Role'
                  name='rolesAndPermissions'
                  value={values.rolesAndPermissions}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.rolesAndPermissions}
                  touched={touched.rolesAndPermissions}
                  isLoading={isFetchingRoles}
                  options={rolesOptions}
                />
                <Select
                  label='Chatbot'
                  placeholder='Select Bot'
                  name='botId'
                  value={values.botId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.botId}
                  touched={touched.rolesAndPermissions}
                  iconLeft={true}
                  isLoading={isFetchingBots}
                  options={botOptions}
                />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default GroupForm;
